import { AdCuePoint, AdObject, AdType } from './ad-types';

function triggerAliased(player: any, eventNames: string[], payload: any) {
  eventNames.forEach((eventName) => {
    player.trigger(eventName, payload);
  });
}

export function triggerAdRequest(
  player: any,
  adType: AdType,
  timestamp: number,
  cuePoint: AdCuePoint
) {
  triggerAliased(player, ['ads-request'], {
    cueId: cuePoint.id,
    cueTime: cuePoint.time,
    timeDiff: timestamp - player.currentPosition,
    live: player.isLive,
    adType,
  });
}

export function triggerAdsReady(
  player: any,
  cuePoint: AdCuePoint,
  ad: AdObject | undefined
) {
  triggerAliased(
    player,
    ['adsready'],
    ad
      ? {
          cueId: cuePoint.id,
          cueTime: cuePoint.time,
          live: player.isLive,
          impressionType: ad.type,
          adName: ad.name,
          target: ad.type === 'VIDEO' ? ad.videos![0].href : ad.images![0].href,
        }
      : undefined
  );
}

export function triggerAdCanceled(
  player: any,
  adType: AdType,
  cuePoint: AdCuePoint
) {
  triggerAliased(player, ['ads-canceled'], {
    cueId: cuePoint.id,
    cueTime: cuePoint.time,
    live: player.isLive,
    adType,
  });
}

export function triggerAdPlay(
  player: any,
  adType: AdType,
  cuePoint: AdCuePoint,
  ad: AdObject,
  variant: string
) {
  triggerAliased(player, ['ads-play', 'adstart'], {
    cueId: cuePoint.id,
    cueTime: cuePoint.time,
    live: player.isLive,
    impressionType: ad.type,
    adName: ad.name,
    target: ad.type === 'VIDEO' ? ad?.videos![0].href : ad?.images![0].href,
    variant,
    adType,
  });
}

export function triggerAdClicked(
  player: any,
  adType: AdType,
  cuePoint: AdCuePoint,
  ad: AdObject,
  variant: string
) {
  triggerAliased(player, ['ads-click'], {
    cueId: cuePoint.id,
    cueTime: cuePoint.time,
    live: player.isLive,
    impressionType: ad.type,
    adName: ad.name,
    target: ad.target,
    variant,
    adType,
  });
}

export function triggerAdSkipped(
  player: any,
  adType: AdType,
  cuePoint: AdCuePoint,
  ad: AdObject,
  variant: string
) {
  triggerAliased(player, ['ads-skipped', 'adskip'], {
    cueId: cuePoint.id,
    cueTime: cuePoint.time,
    live: player.isLive,
    impressionType: ad.type,
    adName: ad.name,
    variant,
    adType,
  });
}

export function triggerAdEnded(
  player: any,
  adType: AdType,
  cuePoint: AdCuePoint,
  ad: AdObject,
  variant: string
) {
  triggerAliased(player, ['ads-ended', 'adend'], {
    cueId: cuePoint.id,
    cueTime: cuePoint.time,
    live: player.isLive,
    impressionType: ad.type,
    adName: ad.name,
    variant,
    adType,
  });
}
